import {
  EThemeType,
  getCustomTheme,
  ICustomTheme
} from '@/modules/common/services/local-storage';

export const isWhitelabelClient = (theme?: ICustomTheme) => {
  const customTheme = theme || getCustomTheme();
  return customTheme && customTheme.type === EThemeType.BrandManaged;
};

export const customizeTitle = (theme?: ICustomTheme) => {
  const customTheme = theme || getCustomTheme();
  const title = document.querySelector('title');
  if (customTheme && isWhitelabelClient(customTheme)) {
    if (title) {
      title.text = customTheme.brandName!;
    }
  }
};
